import React from 'react';
import TagBeta from '../TagBeta';
import Icon from '../Icon';
import { IconName, IconsList } from '../Icon/constants';
import { BASE_CLASS_NAME } from './constants';

export interface MenuItemProps extends React.PropsWithChildren<any> {
  id?: string;
  isBeta?: boolean;
  icon?: IconName | React.ReactElement;
  text: string;
  onSelect?: () => void;
  disabled?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({
  id,
  icon,
  text,
  isBeta = false,
  onSelect,
  disabled = false,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    if (!disabled && onSelect) {
      onSelect();
    }
  };

  return (
    <div
      id={id}
      onClick={handleClick}
      className={BASE_CLASS_NAME}
      aria-disabled={disabled}
    >
      {typeof icon === 'string'
        ? IconsList.includes(icon) && (
            <Icon className={`${BASE_CLASS_NAME}__icon`} name={icon} />
          )
        : icon}
      <span title={text} className={`${BASE_CLASS_NAME}__text`}>
        {text}
      </span>
      {isBeta && (
        <span className={`${BASE_CLASS_NAME}__beta`}>
          <TagBeta />
        </span>
      )}
    </div>
  );
};

export default MenuItem;
